module.exports = __webpack_public_path__ + "img/molodi.b791ae84.jpg";